import { createFileRoute } from "@tanstack/react-router";
import { WorkstationLandingPage } from "@/features/frontline/pages/workstation-landing-page";

export const Route = createFileRoute("/_authed/tenants/$slug/security/frontline/")({ component: WorkstationLandingPage });
